import clsx from 'clsx'
import { useAuth } from '../../../../app/modules/auth'
import { KTSVG, toAbsoluteUrl } from '../../../helpers'
import { HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher } from '../../../partials'
import { useLayout } from '../../core'
import { useSetupContext } from '../../../../app/constructor/helpers/SetupContext'
import {useCallback, useEffect, useMemo, useRef} from 'react'
import { getApiUrl } from '../../../../app/api'
import useMutate from '../../../../app/api/hooks/useMutate'
import ModuleDomRu from '../../../../app/constructor/modules/ModuleDomRu'
import usePrevious from '../../../../app/constructor/helpers/usePrevious'
import useNotifications from '../../../../app/api/hooks/useNotifications'
import ModuleDialog from '../../../../app/constructor/modules/ModuleDialog'
import ModuleDeveloper from '../../../../app/constructor/modules/ModuleDeveloper'
import ModuleSalaryWidgets from '../../../../app/constructor/modules/ModuleSalaryWidgets'
import { getResolvedLink } from '../../../../app/constructor/modules/helpers'
import ModuleMessenger from '../../../../app/constructor/modules/ModuleMessenger'


const itemClass = 'ms-1 ms-lg-3'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px w-md-40px h-md-40px'
const userAvatarClass = 'symbol-35px symbol-md-40px'
const btnIconClass = 'svg-icon-1'

const ComponentNotifications: React.FC = () => {


  /*
  --- Запрос на получение уведомлений, информация по прошлым уведомлениям, запрос на удаление уведомлений 
  */
    const {
        notifications,
        totalCount,
        fetchNextPage,
        hasNextPage,
        refetch
    } = useNotifications()

  const { mutate: mutateRemove, isSuccess: isSuccessRemove } = useMutate<{ id: number }>("notifications", "remove", { success: false, error: false })
  const { mutate: mutateRemoveAll, isSuccess: isSuccessRemoveAll } = useMutate<{}>("notifications", "removeAll", { success: false, error: false })

  const prevMaxIdRef = useRef<number | null>(null)
  const audioRef = useRef<HTMLAudioElement | null>(null)

  useEffect(() => {
     audioRef.current = new Audio(toAbsoluteUrl("/media/crm/sounds/alert.mp3"))
  }, [])

  useEffect(() => {
    if (isSuccessRemove || isSuccessRemoveAll) {
        refetch()
    }
  }, [isSuccessRemove, isSuccessRemoveAll])

  /*
  --- Временно отключил автообновление по причине неисправности. Добавлена цикличность запросов в useNotifications
   */
  /*  useUpdate([{ active: true, update: refetch }], "notifications") */


    useEffect(() => {
        if (!notifications.length) return
        const unique = Array.from(
            new Map(notifications.map(n => [n.id, n])).values()
        )
        const maxId = Math.max(...unique.map(n => n.id))
        if (prevMaxIdRef.current === null) {
            prevMaxIdRef.current = maxId
            return
        }
        if (maxId > prevMaxIdRef.current) {
            audioRef.current?.play().catch(() => {})
        }
        prevMaxIdRef.current = maxId
    }, [notifications])

  const notificationsCount = totalCount

  const handleReadNotification = useCallback((id: number | Array<number>) => {
    if (Array.isArray(id)) {
      mutateRemoveAll({})
    } else {
      mutateRemove({ id })
    }
  }, [mutateRemove, mutateRemoveAll])


  return <div className={clsx('app-navbar-item pulse pulse-primary notifications', itemClass)}>
    <div
      data-kt-menu-trigger="{default: 'click'}"
      data-kt-menu-attach='parent'
      data-kt-menu-placement='bottom-end'
      className={btnClass}
    >
      <KTSVG path='/media/crm/icons/notification.svg' className={`${btnIconClass} notifications_icon`} />

      {notificationsCount ? <>
        <span className="pulse-ring" />
        <span className="notifications_count">{notificationsCount}</span>
      </> : null}
    </div>
      <HeaderNotificationsMenu
          notifications={notifications}
          handleReadNotification={handleReadNotification}
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          totalCount={totalCount}
      />
  </div>
}

const Navbar = () => {
  const { config } = useLayout()
  const { context } = useSetupContext()
  const messenger = context.messengers
  const domain = context.domain
  const chat = context.dialog_widget
  const enableGlobalSearch = Boolean(context.global_search)
  const enableDomRuModule = Boolean(context.dom_ru)
  const { currentUser } = useAuth()
  const showDevMenu = currentUser?.permissions?.some(permission => permission.article === "support") ?? false
  const showSalaryWidget = Boolean(context.salary_widget)


  return (
    <div className='app-navbar flex-shrink-0'>
      {showSalaryWidget ? <ModuleSalaryWidgets /> : null}

      {enableDomRuModule ? <ModuleDomRu /> : null}
      {
        enableGlobalSearch ? <div className={clsx('app-navbar-item', itemClass)}>
          <Search />
        </div> : null
      }

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTSVG path='/media/icons/duotune/general/gen032.svg' className={btnIconClass} />
        </div>
      </div> */}

      <ComponentNotifications />

      {messenger ? <ModuleMessenger filter={domain} /> : null}
      {/* чат отключен до рефакторинга */}
      {chat ? <ModuleDialog {...chat} /> : null}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      {
        showDevMenu ? <div className={clsx('app-navbar-item', itemClass)}>
          <ModuleDeveloper toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
        </div> : null
      }

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <img
            src={getResolvedLink(currentUser?.avatar) ?? toAbsoluteUrl('/media/crm/assets/blank.png')}
            style={{ objectFit: "contain" }}
            alt="header_user_avatar"
            onError={e => {
              const img = e.currentTarget
              if (img.src !== toAbsoluteUrl('/media/crm/assets/blank.png')) {
                img.onerror = null
                img.src = toAbsoluteUrl('/media/crm/assets/blank.png')
              }
            }}
          />
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export { Navbar }
